import { motion } from "framer-motion";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import logo from '../assets/logo.png';
// import { EnvelopeIcon, PhoneIcon, MapPinIcon } from "@heroicons/react/24/outline";

export default function HeaderPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-gray-50"
    >
      {/* Top Contact Bar */}
      {/* <div className="bg-gray-700 py-2 border-b border-gray-600">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-between items-center text-xs text-gray-300">
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-1">
                <a href="mailto:info@value.com" className="hover:text-white transition-colors">
                ✉️ info@value.com
                </a>
              </div>
              <div className="flex items-center space-x-1">
                <a href="tel:+250781234567" className="hover:text-white transition-colors">
                📞 +250 781 234 567
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <span>🏢 400 KN 276 St, Kigali</span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Navigation */}
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src={logo} 
                alt="Value Logo" 
                className="h-32 w-32 rounded-lg transition-transform group-hover:scale-105" 
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          {/* <nav className="hidden lg:flex items-center space-x-8">
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `text-sm font-medium transition-all duration-300 hover:text-white px-3 py-2 rounded-lg ${
                  isActive 
                    ? "text-white bg-gray-400 shadow-lg" 
                    : "text-gray-300 hover:bg-gray-500"
                }`
              }
            >
              About Us
            </NavLink>
            
            <NavLink
              to="/team"
              className={({ isActive }) =>
                `text-sm font-medium transition-all duration-300 hover:text-white px-3 py-2 rounded-lg ${
                  isActive 
                    ? "text-white bg-gray-400 shadow-lg" 
                    : "text-gray-300 hover:bg-gray-500"
                }`
              }
            >
              Our Team
            </NavLink>
            
            <NavLink
              to="/resources"
              className={({ isActive }) =>
                `text-sm font-medium transition-all duration-300 hover:text-white px-3 py-2 rounded-lg ${
                  isActive 
                    ? "text-white bg-gray-400 shadow-lg" 
                    : "text-gray-300 hover:bg-gray-500"
                }`
              }
            >
              Resources
            </NavLink>
          </nav> */}

          {/* Auth Button */}
          {/* <div className="hidden lg:flex items-center">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `px-6 py-2 rounded-lg font-medium text-sm transition-all duration-300 ${
                  isActive
                    ? "bg-gray-200 text-gray-700 shadow-lg"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300 shadow-md hover:shadow-lg"
                }`
              }
            >
              Sign In
            </NavLink>
          </div> */}

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors"
          >
            <div className="w-6 h-6 flex flex-col justify-center space-y-1">
              <span className={`block h-0.5 w-6 bg-white transition-all ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-white transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-white transition-all ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden mt-4 bg-gray-700 rounded-lg p-4 space-y-2"
          >
            <NavLink
              to="/about"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive 
                    ? "bg-gray-600 text-white" 
                    : "text-gray-300 hover:bg-gray-600 hover:text-white"
                }`
              }
            >
              About Us
            </NavLink>
            
            <NavLink
              to="/team"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive 
                    ? "bg-gray-600 text-white" 
                    : "text-gray-300 hover:bg-gray-600 hover:text-white"
                }`
              }
            >
              Our Team
            </NavLink>
            
            <NavLink
              to="/resources"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive 
                    ? "bg-gray-600 text-white" 
                    : "text-gray-300 hover:bg-gray-600 hover:text-white"
                }`
              }
            >
              Resources
            </NavLink>
            
            <NavLink
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive 
                    ? "bg-gray-600 text-white" 
                    : "bg-gray-500 text-white hover:bg-gray-600"
                }`
              }
            >
              Sign In
            </NavLink>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
}